<template src="./template.html"/>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable */
export default {
  name: 'progressCard',
  props: {
    iconName: {
      type: String,
      default: 'airplane'
    },
    text: {
      type: String,
      default: 'Test.csv',
    },
    progressId: {
      type: String,
      default: '',
    },
    position: {
      type: [String, Number],
      default: 0,
    },
    type: {
      type: String,
      default: '',
    },
    templateType: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      data: 'data',
      progress: 0,
    };
  },
  computed: {
    ...mapGetters([
      'get_import_queue_ids',
      'get_reports_list',
      'get_import_queue',
    ]),
  },
  mounted() {
    if (!this.get_import_queue_ids.includes(this.progressId)) {
      this.trackProgressImport();
    } else {
      this.progress = 100;
    }
  },
  methods: {
    trackProgressImport() {
      this.$store.dispatch('TRACK_IMPORT_PROGRESS', this.progressId)
        .then((res) => {
          if (res.data.data !== 'progress-done') {
            this.progress = res.data.data;
            // Update progress in que
            this.$store.dispatch('UPDATE_IN_QUEUE', {
              progressId: this.progressId,
              progressStatus: this.progress,
            });
            var self = this;
            localStorage.setItem('importQueue', JSON.stringify(this.get_import_queue))
            setTimeout(() => {
              self.trackProgressImport();
            }, 5000);
          } else {
            this.progress = 100;
            this.$store.dispatch('UPDATE_IN_QUEUE', {
              progressId: this.progressId,
              progressStatus: this.progress,
            })
            this.$store.dispatch('STORE_ID_QUEUE', this.progressId);

            const localStorageContent = JSON.parse(localStorage.getItem('importQueue'));
            const filteredArray = localStorageContent.filter(progress => progress.progressId != this.progressId);

            localStorage.setItem('importQueue', JSON.stringify(filteredArray))
          }
        });
    },
    removeFromQueue() {
      if (this.progress === 100) {
        this.$store.dispatch('REMOVE_FROM_QUEUE', this.progressId);
      }
    },
    downloadReport() {
      const importQueue = this.get_import_queue.find(item => item.progressId == this.progressId);
      if (importQueue) {
        const reportItem = this.get_reports_list.items.find(item => item.id == importQueue.id);
        if (reportItem) {
          this.$store.dispatch('DOWNLOAD_REPORT', reportItem.id).then((res) => {
            this.$nextTick(() => {
              const url = window.URL.createObjectURL(new Blob([res], {type: "octet/stream"}));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.text);
              document.body.appendChild(link);
              link.click();
              setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              }, 200);
            })
          })
        }
      }
    }
  },
}
</script>
